/**
 * Logins user.
 */
export function login() {
	const loginmodal = document.querySelector( '.modal-login' );
	if ( !loginmodal ) {
		return;
	}

	window.mce = 'mce' in window ? window.mce : {};

	const innerContainer = loginmodal.querySelector( '.modal-inner-container' );
	const usernameInput = loginmodal.querySelector( '.login-username-input' );
	const passwordInput = loginmodal.querySelector( '.login-password-input' );
	const entryInput = loginmodal.querySelector( '.login-ime-entry-id' );
	const completionStatusInput = loginmodal.querySelector( '.login-ime-entry-completion-status' );
	const form = loginmodal.querySelector( '.modal-login-form' );
	const errorsContainer = loginmodal.querySelector( '.validation_error' );
	const loaderButton = loginmodal.querySelector( '.loader' );

	const formData = {};
	let redirectUrl = innerContainer.dataset.redirect;

	const completionStatus = completionStatusInput ? completionStatusInput.value : 'submitted';

	if ( entryInput ) {
		if ( $( entryInput ).attr( 'shared' ) === '1' ) {
			// User comes from share claim email link.
			redirectUrl = `${window.location.pathname}`;
		} else {
			// Logs In for saving or submitting a IME Form.
			formData.entry_id = entryInput.value;
			redirectUrl = `${window.location.pathname}
			?status=logged-in
			&completion-status=${completionStatus}`;
		}
	}

	$( form ).on( 'submit', ( event ) => {
		event.preventDefault();

		// Clean errors container.
		errorsContainer.innerHTML = '';
		loaderButton.classList.add( 'active' );

		formData.username = usernameInput.value;
		formData.password = passwordInput.value;

		$.ajax({
			url: `${window.mce.api_url}login`,
			type: 'post',
			data: formData,
			success: function( data ) {
				if ( data.success ) {
					window.location = redirectUrl;
				} else {
					errorsContainer.classList.remove( 'visuallyhidden' );
					loaderButton.classList.remove( 'active' );
					errorsContainer.innerHTML = data.message;
				}
			}
		});
	});
}